import React, {useEffect} from "react";
import {Card} from "react-bootstrap";
import {Location, SettingsDoc, Stats, User} from "../types/Types";
import {getAuth, onAuthStateChanged} from "firebase/auth";
import PageTracking from "../auth/PageTracking";
import {Link, useNavigate} from "react-router-dom";
import RecentPhotosWidget from "./widgets/RecentPhotosWidget";
import StatsWidget from "./widgets/StatsWidget";
import NewsHeadlinesWidget from "./widgets/NewsHeadlinesWidget";
import PhotoOfTheMonthWidget from "./widgets/PhotoOfTheMonthWidget";
import UpcomingEventsWidget from "./widgets/UpcomingEventsWidget";
import CountriesWidget from "./widgets/CountriesWidget";

interface Props {
    currentUser: User | undefined
    stats: Stats | undefined
    settings: SettingsDoc | undefined
    locations: Location[]
}

function Home(props: Props) {
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            const auth = getAuth();
            onAuthStateChanged(auth, async (currentUser) => {
                if (!currentUser) {
                    navigate('/');
                    return;
                }
            });
        })();
    }, [navigate]);

    return (
        <>
            <PageTracking />
            {!props.currentUser && <>
                <Card>
                    <div className={'loading'}>Loading...</div>
                </Card>
            </>}
            {props.currentUser && <>
                <div className="mb-2">
                    <div className="d-inline-block"><h5>Welcome {props.currentUser && <strong>{props.currentUser.name}!</strong>}</h5></div>
                    <div className="d-inline-block float-right" style={{fontSize: "0.7rem"}}><Link to="/updates" data-discover="true">What's new?</Link></div>
                </div>
                <UpcomingEventsWidget
                    socialDisabled={props.currentUser.socialDisabled}
                    currentUser={props.currentUser}
                />
                <RecentPhotosWidget socialDisabled={props.currentUser.socialDisabled} />
                <PhotoOfTheMonthWidget 
                    socialDisabled={props.currentUser.socialDisabled} 
                    currentUser={props.currentUser}
                />
                {!props.currentUser.socialDisabled && <NewsHeadlinesWidget />}
                <CountriesWidget 
                    locations={props.locations} 
                    socialDisabled={props.currentUser.socialDisabled}
                />
                <StatsWidget 
                    stats={props.stats} 
                    socialDisabled={props.currentUser.socialDisabled}
                    isFirstCard={false}
                />
            </>}
        </>
    )
}

export default Home;